/**
 * @desc 根据售后地址查询附近售后网点信息
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** 售后地址信息 */
  address?: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.WrapResponse<defs.store.AfterSaleAddressStoreVO>>(
    `/storeapi/after/sale/address/nearby`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.WrapResponse<defs.store.AfterSaleAddressStoreVO>;
export default req;
